import common from '@/services/common'

export default {
    async getLocalizedStrings() {
        return common.executeExternal('get', `${process.env.VUE_APP_STRING_OVERRIDE_CLOUD_FUNCTION_BASE_URL}/localizedstrings/`)
    },
    async postNewOverrides(newOverridesJson){
        return common.executeExternal('post', `${process.env.VUE_APP_STRING_OVERRIDE_CLOUD_FUNCTION_BASE_URL}/stringOverrides`, newOverridesJson)
    },
    async promoteToProd(){
        return common.executeExternal('post', `${process.env.VUE_APP_STRING_OVERRIDE_CLOUD_FUNCTION_BASE_URL}/promote`)
    },
}